import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { getAllClearingItems, retrySmsOneMore, getSmsAlertHistory } from '../../../actions/ssmActions';
import { getBranchList } from '../../../actions/commonAction';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';
import { getBranchById } from '../../../utilities/common';

const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex',
        color: 'black',
    },
    flexCount: {
        display: 'flex',
        margin: '20px 0'
    },
    count: {
        backgroundColor: '#dc3545',
        color: 'white',
        marginLeft: '5px',
        padding: '0 10px',
        borderRadius: '10px'
    },
    typography: {
        padding: theme.spacing(2),
        backgroundColor: '#fff',
        color: '#303030 !important',
        borderRadius: '5px'
    },
    showOnTop: {
        zIndex: '9999'
    },
    replyColor: { 
        color: '#303030' 
    },
    tableRowColor: { 
        background: '#212121' 
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    tableCellContentFormat: { 
        textAlign: 'center' 
    },
    replyFormat: { 
        textAlign: 'center', 
        width: '90px', 
        whiteSpace: 'nowrap', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis', 
        paddingLeft: '40px', 
        cursor: 'pointer' 
    },
    alertHistoryStyle: {
        display: 'flex',
        flexDirection: 'column',
    }
}))

const ColorButton = withStyles((theme) => ({
    root: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        minWidth: '30px !important',
        marginLeft: '10px'
    },
}))(Button);

function BatchSub(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('storageScan');
    const { rows, rowsDisplayTrans, rowsFilterReplyTrans, rowsFilterRetriedTrans, batchSendNo, id } = props;
    
    const [rowsDisplay, setRowsDisplay] = useState([]);
    const [expandedToScan, setExpandedToScan] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [placement, setPlacement] = useState();
    const [replyFull, setReplyFull] = useState('');
    const [filterReply, setFilterReply] = useState(true);
    const [rowsFilterReply, setRowsFilterReply] = useState([]);
    const [filterRetried, setFilterRetried] = useState(true);
    const [rowsFilterRetried, setRowsFilterRetried] = useState([]);
    const [retryOpen, setRetryOpen] = useState(false);
    const [tno, setTno] = useState('');
    const [retryMsg, setRetryMsg] = useState('');
    const [alertHistory, setAlertHistory] = useState([]);
    const [branches, setBranches] = useState([]);
    const [length, setLength] = useState(0);

    useEffect(() => {
        if(rowsDisplayTrans) {
            setRowsDisplay(rowsDisplayTrans);
        }
    }, [rowsDisplayTrans])
    useEffect(() => {
        if(rowsFilterReplyTrans) {
            setRowsFilterReply(rowsFilterReplyTrans);
        }
    }, [rowsFilterReplyTrans])
    useEffect(() => {
        if(rowsFilterRetriedTrans) {
            setRowsFilterRetried(rowsFilterRetriedTrans);
        }
    }, [rowsFilterRetriedTrans])
    useEffect(() => {
        dispatch(getBranchList()).then((branches)=>{
            setBranches(branches);
        })
    }, [])
    useEffect(() => {
        setLength(rows.length)
    }, [rows])

    // Storage accordions
    const handleChangeToScan = (panel) => (event, isExpanded) => {
        setExpandedToScan(isExpanded ? panel : false);
    };

    const handleClickReply = (newPlacement, reply) => (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((prev) => placement !== newPlacement || !prev);
        setPlacement(newPlacement);
        setReplyFull(reply);
    };

    const handleRetryClose = () => {
        setRetryOpen(false);
    };

    // Control the checkbox of reply in 
    function filterRowsByReply() {
        setFilterReply(!filterReply);
        const rowsTemp = [];
        if(filterReply) {
            if(filterRetried) {
                for(const row of rows) {
                    if(row.reply) {
                        rowsTemp.push(row);
                    }
                }
                setRowsFilterReply(rowsTemp)
                setRowsDisplay(rowsTemp);
            } else {
                for(const row of rowsFilterRetried) {
                    if(row.reply) {
                        rowsTemp.push(row);
                    }
                }
                setRowsDisplay(rowsTemp);
            }
        } else {
            if(filterRetried) {
                setRowsDisplay(rows);
            } else {
                setRowsDisplay(rowsFilterRetried);
            }
        }
    }
    // Control the checkbox of retried in 
    function filterRowsByRetried() {
        setFilterRetried(!filterRetried);
        const rowsTemp = [];
        if(filterRetried) {
            if(filterReply) {
                for(const row of rows) {
                    if(row.retried) {
                        rowsTemp.push(row);
                    }
                }
                setRowsFilterRetried(rowsTemp);
                setRowsDisplay(rowsTemp);
            } else {
                for(const row of rowsFilterReply) {
                    if(row.retried) {
                        rowsTemp.push(row);
                    }
                }
                setRowsDisplay(rowsTemp);
            }
        } else {
            if(filterReply) {
                setRowsDisplay(rows);
            } else {
                setRowsDisplay(rowsFilterReply);
            }
        }
    }
    
    // Retried plus one
    function handleClickRetried() {
        dispatch(retrySmsOneMore(props.warehouse, batchSendNo, tno, retryMsg)).then(() => {
            dispatch(getAllClearingItems(batchSendNo))
            .then(() => {
                setRetryOpen(false);
            })
        })
    };

    function handleClickPlusOne(batchSendNo, tno) {
        dispatch(getSmsAlertHistory(batchSendNo, tno, props.warehouse))
        .then((res) => {
            if(res.data) {
                setAlertHistory(res.data);
            } else {
                setAlertHistory([]);
            }
        })
        setRetryOpen(true);
        setTno(tno);
    }

    return (
        <>
            <Dialog open={retryOpen} onClose={handleRetryClose} maxWidth="lg" fullWidth>
                <DialogTitle id="form-dialog-title">{t('retry_history')}</DialogTitle>
                <DialogContent>
                <DialogContentText className={classes.alertHistoryStyle}>
                    <Table>
                        <TableHead>
                            <TableRow className={classes.tableRowColor}>
                                <TableCell className={classes.tableCellFormat}>{t('batch_send_no')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('tno')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('send_time')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('phone')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('send_msg')}</TableCell>        
                                <TableCell className={classes.tableCellFormat}>{t('reply')}</TableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                (alertHistory.length > 0) && alertHistory.map((alert, index) => {
                                    return (
                                        <TableRow 
                                            key={alert.id}
                                            style={ index % 2? { background : "#424242" }:{ background : "#303030" } }
                                        >
                                            <TableCell className={classes.tableCellContentFormat}>{alert.batch_send_no}</TableCell>
                                            <TableCell className={classes.tableCellContentFormat}>{alert.tno}</TableCell>
                                            <TableCell className={classes.tableCellContentFormat}>{moment.unix(alert.send_time).format("YYYY-MM-DD, HH:mm:ss")}</TableCell>
                                            <TableCell className={classes.tableCellContentFormat}>{alert.phone}</TableCell>
                                            <TableCell className={classes.tableCellContentFormat}>{alert.send_msg}</TableCell>
                                            <TableCell className={classes.tableCellContentFormat}>
                                                {
                                                    alert.replied === 0 && t('no_replied')
                                                }
                                                {
                                                    alert.replied === 1 && t('replied')
                                                }
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </DialogContentText>
                <TextField
                    multiline
                    style={{ width: '100%' }}
                    variant="outlined"
                    placeholder="Please input send message"
                    onChange={(e) => setRetryMsg(e.target.value)}
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={handleRetryClose} color="primary">
                    {t('cancel')}
                </Button>
                <Button onClick={handleClickRetried} color="primary">
                    {t('retry')}
                </Button>
                </DialogActions>
            </Dialog>
            <Popper open={open} anchorEl={anchorEl} placement={placement} transition className={classes.showOnTop}>
                {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={60}>
                    <Paper>
                        <Typography className={classes.typography}><div className={classes.replyColor}>{replyFull}</div></Typography>
                    </Paper>
                </Fade>
                )}
            </Popper>
            <Accordion expanded={expandedToScan === 'panel1'} onChange={handleChangeToScan('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className={ classes.flexCount }
                >
                {(id === 'toBeScanned') && <Typography >{t('pending_scan')}</Typography>}
                {(id === 'scanned') && <Typography >{t('scanned')}</Typography>}
                <Typography className={classes.count}>{ length }</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Table>
                        <TableHead>
                            <TableRow className={classes.tableRowColor}>
                                <TableCell className={classes.tableCellFormat}>{t('batch_no')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('batch_send_no')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('tno')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('phone')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('warehouse')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('storage_info')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('driver_notes')}</TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('reply')}
                                    <Checkbox
                                        onClick={filterRowsByReply}
                                        color="primary"
                                        inputprops={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('retried')}
                                    <Checkbox
                                        onClick={filterRowsByRetried}
                                        color="primary"
                                        inputprops={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </TableCell>
                                <TableCell className={classes.tableCellFormat}>{t('status')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {rowsDisplay.map((row, index) => (
                            <TableRow 
                                key={row.id + id}
                                style={ index % 2? { background : "#424242" }:{ background : "#303030" } }
                            >
                                <TableCell className={classes.tableCellContentFormat}>{row.batch_no}</TableCell>
                                <TableCell className={classes.tableCellContentFormat}>{row.batch_send_no}</TableCell>
                                <TableCell className={classes.tableCellContentFormat}>{row.tno}</TableCell>
                                <TableCell className={classes.tableCellContentFormat}>{row.phone}</TableCell>
                                <TableCell className={classes.tableCellContentFormat}>
                                    {
                                        getBranchById(row.warehouse).short_name
                                    }
                                </TableCell>
                                <TableCell className={classes.tableCellContentFormat}>{row.storage_info}</TableCell>
                                <TableCell className={classes.tableCellContentFormat}>{row.driver_notes}</TableCell>
                                <TableCell className={classes.tableCellContentFormat}>
                                    <div 
                                    className={classes.replyFormat}
                                    onClick={handleClickReply('bottom', row.reply)}
                                >
                                    {row.reply}</div></TableCell>
                                <TableCell className={classes.tableCellContentFormat}>
                                    {row.retried}  
                                    <ColorButton
                                        onClick={() => {handleClickPlusOne(row.batch_send_no, row.tno)}}
                                        color="primary"
                                        inputprops={{ 'aria-label': 'secondary checkbox' }}
                                    >
                                        +1
                                    </ColorButton>
                                </TableCell>
                                <TableCell className={classes.tableCellContentFormat}>{row.status}</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default BatchSub;